export enum AppRoutes {
    myFiles = '/my-files',
    sharedWithMe = '/shared-with-me',
    allFiles = '/all-files',
    myWorkspaces = '/my-workspaces',
    policyEditor = '/policy-editor',
    userRoleEditor = '/users-editor',
    auditLogs = '/audits',
    settings = '/Settings',
}

/** Route for integration configuration drill-down page (not a menu item) */
export const INTEGRATION_CONFIG_ROUTE = '/Settings/integration';

export type RoutesListType = AppRoutes[];

export const APP_ROUTES_DEFAULT: RoutesListType = Object.values(AppRoutes);

export enum ExternalStorageRoutes {
    gdrive = '/gdrive/share',
    box = '/box/share',
}

export const VIEWER_ROUTE = '/viewer';
export const VIEWER_ROUTE_TEMPLATE = `${VIEWER_ROUTE}/:id`;

/**
 * Dev-only preview route for the load-error report screen. Pre-auth and gated by
 * IS_NON_PROD_ENV in Root, so it is reachable on local/dev/staging but never prod.
 */
export const DEV_LOAD_ERROR_PREVIEW = '/dev/load-error';

export const EXTERNAL_STORAGE_ROUTES_SET = new Set<ExternalStorageRoutes>(Object.values(ExternalStorageRoutes));

export const APP_ADDITIONAL_ROUTES_TEMPLATES = [VIEWER_ROUTE_TEMPLATE, ...EXTERNAL_STORAGE_ROUTES_SET];

export const CROSS_ORIGIN_OAUTH = '/cross-origin-oauth';
export const SIGN_IN_PATHNAME = 'signin';

export enum MiniAppRoutes {
    sharedFile = '/shared-file',
    giveAccess = '/give-access',
    sharedWorkspace = '/request-file',
}

export const MINI_APPS_PATH_NAMES_LIST: MiniAppRoutes[] = Object.values(MiniAppRoutes);
export const ALLOWED_ROUTES_FOR_UNAUTHORIZED = [MiniAppRoutes.sharedFile];
